import { createContext } from "react";

import makeIacManagementStore from "./useIacManagementStore/makeIacManagementStore";

type IacManagementPageStoreContextValue = ReturnType<typeof makeIacManagementStore>;

export const IacManagementPageStoreContext = createContext<
  IacManagementPageStoreContextValue | undefined
>(undefined);
